import { ApiService } from '@b2b/common/services/api/types';
import { IInjectable, StateParams } from '@uirouter/angularjs';

export function OrderDataResolver(): IInjectable {
  return [
    '$stateParams',
    'ApiService',
    function ($stateParams: StateParams, ApiService: ApiService) {
      return ApiService.orders.willCall.order($stateParams.orderId);
    },
  ];
}

export function OrderFormsDataResolver(): IInjectable {
  return [
    '$stateParams',
    'ApiService',
    function ($stateParams: StateParams, ApiService: ApiService) {
      return ApiService.orders.forms.list({ orderId: $stateParams.orderId });
    },
  ];
}
